import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { InitService } from '@core/services/init.service';

@Component({
  selector: 'app-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app-footer.component.html',
})
export class AppFooterComponent implements OnInit {
  private readonly initService = inject(InitService);

  readonly version = signal<string | undefined>(undefined);

  ngOnInit(): void {
    this.initService.getVersion().subscribe({
      next: (version) => this.version.set(version),
      error: () => this.version.set(undefined)
    });
  }
}
